import { makeServerRequest } from './util';

const apiPrefix = "/api/v1/customers";

export const fetchBranches = (customerId) => {

    return (dispatch) => {
        dispatch({type: "FETCH_BRANCHES"});

        return makeServerRequest(apiPrefix + "/" + customerId + "/branches?size=1000&sort=name,asc").then(
            response => dispatch(fetchBranchesSuccess(response.data))
        ).catch(
            error => dispatch(fetchBranchesFailure(error))
        );
    };
};

export function fetchBranchesSuccess(customer) {
    return {
        type: "FETCH_BRANCHES_SUCCESS",
        payload: customer
    };
}

export function fetchBranchesFailure(error) {
    return {
        type: "FETCH_BRANCHES_FAILURE",
        payload: error
    };
}

export const fetchFilteredBranches = (customerId, key) => {
    return (dispatch) => {
        dispatch({type: "FETCH_FILTERED_BRANCHES", payload: key});

        return makeServerRequest(apiPrefix + "/" + customerId + "/branches?size=1000&sort=name,asc&name=" + key).then(
            response => dispatch(fetchFilteredBranchesSuccess(response.data))
        ).catch(
            error => dispatch(fetchFilteredBranchesFailure(error))
        );
    };
};

export function fetchFilteredBranchesSuccess(customer) {
    return {
        type: "FETCH_FILTERED_BRANCHES_SUCCESS",
        payload: customer
    };
}

export function fetchFilteredBranchesFailure(error) {
    return {
        type: "FETCH_FILTERED_BRANCHES_FAILURE",
        payload: error
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/branches.js